export default __webpack_public_path__ + "static/media/hair-8-3.f3610e65.svg";